<template>
<v-row v-if="showTable">
  <v-col cols="12">
    <v-card class="pa-4">
      <v-card-title class="text-h6">
        <h2>تقسیم وزن فاکتور</h2>
      </v-card-title>
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-center">#</th>
            <th class="text-center">واحد کالا</th>
            <th class="text-center">مقدار کالا</th>
            <th class="text-center">تعداد بسته</th>
            <th class="text-center">عملیات</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in weightSplits" :key="index">
            <td class="text-center">{{ index + 1 }}</td>
            <td class="text-center">
              <v-select v-model="weightSplits[index].n" item-text="title" item-value="n" label="واحد کالا" :items="units" @change="calculateRemainingWeight(index)" />
            </td>
            <td class="text-center">
              <v-text-field v-model.number="weightSplits[index].weight" type="number" min="0" />
            </td>
            <td class="text-center">
              <v-text-field v-model.number="weightSplits[index].count" type="number" min="1" />
            </td>
            <td class="text-center">
              <v-btn v-if="!disableAddRow" icon small color="primary" @click="addWeightRow(index)">
                <v-icon>mdi-plus</v-icon>
              </v-btn>

              <v-btn icon small color="grey darken-4" @click="printRow(row)">
                <v-icon>mdi-printer-pos</v-icon>
              </v-btn>

              <v-btn icon small color="red" @click="removeWeightRow(index)" v-if="weightSplits.length > 1">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>

          </tr>
          <tr class="total">
            <td colspan="2" style="text-align: left">مجموع :</td>
            <td colspan="3">
              <h2 :style="{ color: totalColor }">
                <span class="font-weight-bold" style="color: var(--v-theme-primary)">
                  {{ totalWeightDisplay }}
                </span>
                <span style="color: gray; margin-right: 4px">
                  {{ invoiceWeight.unit }}
                </span>
              </h2>
            </td>
          </tr>

          <tr class="total">
            <td colspan="2" style="text-align: left">مقدار وزن فاکتور :</td>
            <td colspan="3">
              <h2 :style="{ color: totalColor }">
                <span class="font-weight-bold" style="color: var(--v-theme-primary)">
                  {{ invoiceWeight.weight }}
                </span>
                <span style="color: gray; margin-right: 4px">
                  {{ invoiceWeight.unit }}
                </span>
              </h2>
            </td>
          </tr>

        </tbody>
      </v-simple-table>

      <v-card-text class="text-center mt-3">
        <v-alert v-if="isOverWeight" type="warning" dense class="mt-2">
          <h2>مجموع وزن‌ها نباید بیشتر از وزن فاکتور باشد</h2>
        </v-alert>
      </v-card-text>
    </v-card>
  </v-col>
</v-row>
</template>

<script>
import utils from '../../functions/utils';

export default {
  name: 'invoicePrintLabel',
  props: ['alert', 'showWeightTable', 'invoice'],
  data() {
    return {
      showTable: this.showWeightTable,
      units: [],
      weightSplits: [],
      invoiceWeight: {},
    }
  },
  computed: {
    invoiceWeightBase() {
      return (this.invoiceWeight?.weight || 0) * (this.invoiceWeight?.n || 1)
    },
    totalWeightBase() {
      return this.weightSplits.reduce((acc, w) => {
        const wt = Number(w.weight) || 0
        const n = Number(w.n) || 1
        const c = Number(w.count) || 1
        return acc + (wt * n * c)
      }, 0)
    },
    isOverWeight() {
      // آیا مجموع از وزن فاکتور بیشتر شده؟
      return this.totalWeightBase > this.invoiceWeightBase + 1e-9
    },
    totalWeightDisplay() {
      this.$emit("getWS", this.weightSplits)
      //
      const n = this.invoiceWeight?.n || 1
      const v = this.totalWeightBase / n
      // return Number(Math.round(v * 1000) / 1000)
      return utils.round3(v)
    },
    disableAddRow() {
      return this.totalWeightBase >= this.invoiceWeightBase - 1e-9
    },
    totalColor() {
      const total = this.totalWeightBase
      const invoice = this.invoiceWeightBase

      if (Math.abs(total - invoice) < 1e-6) return 'green'
      if (total > invoice) return 'red'
      return 'orange'
    },
  },
  watch: {
    showWeightTable(newVal) {
      if (newVal && this.invoice?.items?.length) {
        const product = this.invoice.products.filter(product => product._id === this.invoice.items[0].product_id)[0]
        this.units = product.unit2 ? [{
          n: 1,
          title: product.unit1
        }, {
          n: product.n,
          title: product.unit2
        }] : [{
          n: 1,
          title: product.unit1
        }];
        let unit = this.units[0]
        // console.log(unit);
        if (product.n && this.invoice.items[0].second_value) unit = this.units[1]
        let Weight = this.invoice.items.reduce((sum, item) => sum + Math.abs((Number(item.value / unit.n)) || 0), 0)
        Weight = Math.ceil(Number(Weight) * 1000) / 1000
        //
        this.invoiceWeight = {
          weight: Weight,
          n: unit.n,
          unit: unit.title
        }
        //
        this.weightSplits = [{
          weight: Weight,
          n: unit.n,
          count: 1
        }]
        //
        this.showTable = true
      }
      //focus
      this.$nextTick(() => {
        const firstInput = this.$el.querySelector('tbody tr:first-child input')
        if (firstInput) firstInput.focus()
      })
    },
  },
  methods: {
    printRow(row) {
      this.$emit('child-print-row', row)
    },
    SumOfWeightsWithoutThisRow(index) {
      const otherRowsTotal = this.weightSplits
        .filter((_, i) => i !== index)
        .reduce((acc, w) => {
          const weight = Math.abs(Number(w.weight)) || 0
          const n = Number(w.n) || 1
          const c = Number(w.count) || 1
          return acc + (weight * n * c)
        }, 0)

      return (this.invoiceWeight.weight * this.invoiceWeight.n) - otherRowsTotal
    },
    calculateRemainingWeight(index) {
      const row = this.weightSplits[index]
      if (!row) return

      const remaining = this.SumOfWeightsWithoutThisRow(index)
      const n = Number(row.n) || 1
      const c = Number(row.count) || 1
      //
      if (index === this.weightSplits.length - 1) {
        row.weight = n && c ? (remaining / (n * c)) : 0
      } else {
        //
        const prevUnit = row.prevUnit || row.n
        const n = Number(row.n) || 1
        const c = Number(row.count) || 1
        if (prevUnit && row.weight) {
          row.weight = ((row.weight * prevUnit) / (n * c))
        }
      }
      row.prevUnit = row.n
    },
    addWeightRow(index) {
      const remaining = this.SumOfWeightsWithoutThisRow(index + 1)
      this.weightSplits.splice(index + 1, 0, {
        weight: remaining / (this.weightSplits[index].n),
        n: this.weightSplits[index].n,
        count: 1
      })
    },
    removeWeightRow(index) {
      if (this.weightSplits.length > 1) this.weightSplits.splice(index, 1)
    },
  },
}
</script>
<style scoped>
.total h2 {
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
